import { render, staticRenderFns } from "./assessments.vue?vue&type=template&id=b6214fe0&scoped=true&"
import script from "./assessments.vue?vue&type=script&lang=js&"
export * from "./assessments.vue?vue&type=script&lang=js&"
import style0 from "./assessments.vue?vue&type=style&index=0&id=b6214fe0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6214fe0",
  null
  
)

export default component.exports